/* =========================================================
   INBUS – Dawn 15.4.1
   Thumbnail click -> single smooth scroll (no stutter)
   - "nearest" behavior, but with extra breathing room
   - padding is based on the actual CSS gap (tablet/desktop differ)
   - Only on click (no variant-change logic)
   ========================================================= */

(() => {
  const MQ = window.matchMedia('(min-width: 750px)'); // set to 990 if you want desktop-only

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getSliderFromTarget(t) {
    return t.closest?.('media-gallery .thumbnail-slider') || null;
  }

  function getThumbButtonFromTarget(t) {
    return (
      t.closest?.('media-gallery .thumbnail-slider button.thumbnail') ||
      t.closest?.('media-gallery .thumbnail-slider .thumbnail-list__item button') ||
      t.closest?.('media-gallery .thumbnail-slider button') ||
      null
    );
  }

  function getActiveThumbButton(slider) {
    return (
      slider.querySelector('button.thumbnail[aria-current="true"]') ||
      slider.querySelector('.thumbnail-list__item[aria-current="true"] button') ||
      slider.querySelector('.thumbnail-list__item--active button') ||
      null
    );
  }

  function getThumbScroller(slider) {
    // In Dawn, this is usually the vertical scroller after your CSS changes
    return (
      slider.querySelector('.thumbnail-list') ||
      slider.querySelector('.slider') ||
      slider.querySelector('.slider-viewport') ||
      slider
    );
  }

  function getGapPx(scroller) {
    const cs = getComputedStyle(scroller);
    const g = parseFloat(cs.rowGap || cs.gap || '0');
    return Number.isFinite(g) ? g : 0;
  }

  /**
   * Scroll the scroller so that btn is visible with some padding.
   * Uses ONE smooth scrollTo => no stutter.
   */
  function scrollThumbIntoViewWithPad(slider, btn) {
    const scroller = getThumbScroller(slider);
    if (!scroller || !btn) return;

    const maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
    if (maxScroll <= 1) return;

    const gap = getGapPx(scroller) || 12;

    // Your wish: "half a gap more" => 1.5x gap padding
    const pad = gap * 2;

    const sr = scroller.getBoundingClientRect();
    const br = btn.getBoundingClientRect();

    // Element position relative to scroller viewport
    const topRel = br.top - sr.top;
    const bottomRel = br.bottom - sr.top;

    const viewTop = pad;
    const viewBottom = scroller.clientHeight - pad;

    // If fully inside padded viewport => nothing to do
    if (topRel >= viewTop && bottomRel <= viewBottom) return;

    let target = scroller.scrollTop;

    // If clipped/too high => move up so element top aligns to viewTop
    if (topRel < viewTop) {
      target += (topRel - viewTop);
    }
    // If clipped/too low => move down so element bottom aligns to viewBottom
    else if (bottomRel > viewBottom) {
      target += (bottomRel - viewBottom);
    }

    target = clamp(target, 0, maxScroll);

    // ONE smooth scroll
    scroller.scrollTo({ top: target, behavior: 'smooth' });
  }

  onReady(() => {
    document.addEventListener(
      'click',
      (e) => {
        if (!MQ.matches) return;

        const btn = getThumbButtonFromTarget(e.target);
        if (!btn) return;

        const slider = getSliderFromTarget(btn);
        if (!slider) return;

        // Wait for Dawn to update aria-current after click
        requestAnimationFrame(() => {
          setTimeout(() => {
            const active = getActiveThumbButton(slider) || btn;
            scrollThumbIntoViewWithPad(slider, active);
          }, 60);
        });
      },
      true // capture
    );
  });
})();